// src/components/AdminRoute.js
import { Navigate } from "react-router-dom";
import { parseJWT } from "../utils/jwtUtils";

const AdminRoute = ({ children }) => {
  const stored = localStorage.getItem("userInfo");

  if (!stored) {
    return <Navigate to="/" replace />;
  }

  try {
    const parsed = JSON.parse(stored);
    const userInfo = parseJWT(parsed.token);

    const isAdmin =
      userInfo?.role === "admin" || userInfo?.role === "super_admin";

    if (!isAdmin) {
      return <Navigate to="/" replace />;
    }

    return children;
  } catch (err) {
    return <Navigate to="/" replace />;
  }
};

export default AdminRoute;
